import { HandHoldingDollarSolid } from '@allocab/allocab-icons';

import { AllocabXStripe } from './AllocabXStripe';
import { CreateMerchantAccountButton } from './CreateMerchantAccountButton';
import { GoToStripeDashboardButton } from './GoToStripeDashboardButton';
import { GoToStripeOnboardingButton } from './GoToStripeOnboardingButton';
import { BadgeIndicator } from '../../components/BadgeIndicator';
import { InfoBox } from '../../components/InfoBox';
import { Spinner } from '../../components/Spinner';
import { useFetchMerchantAccountStatus } from '../../hooks/useFetchMerchantAccountStatus';
import { t } from '../../services/translation/translation';

export const TapToPaySection = () => {
  const {
    data: merchantAccount,
    isFetching,
    isFetched,
  } = useFetchMerchantAccountStatus({ refetchOnWindowFocus: true });

  return (
    <div>
      <h6 className="text-lg font-bold dark:text-white flex items-center gap-2 mb-2">
        <HandHoldingDollarSolid width={16} height={16} className="fill-current" />
        {t('settings-route.t2p-title')}
        {merchantAccount ? (
          <BadgeIndicator
            variant={
              merchantAccount.validationState === 'NOT_CREATED'
                ? 'gray'
                : merchantAccount.validationState === 'INFO_NEEDED'
                ? 'yellow'
                : merchantAccount.validationState === 'VALIDATING'
                ? 'blue'
                : merchantAccount.validationState === 'GRANTED'
                ? 'green'
                : 'gray'
            }
          >
            {merchantAccount.validationState === 'NOT_CREATED'
              ? t('settings-route.t2p.not-created')
              : merchantAccount.validationState === 'INFO_NEEDED'
              ? t('settings-route.t2p.info-needed')
              : merchantAccount.validationState === 'VALIDATING'
              ? t('settings-route.t2p.validating')
              : merchantAccount.validationState === 'GRANTED'
              ? t('settings-route.t2p.granted')
              : t('common.unknown')}
          </BadgeIndicator>
        ) : null}
        {isFetching ? <Spinner /> : null}
      </h6>
      <div className="flex flex-col lg:flex-row gap-2">
        <AllocabXStripe className="self-center shrink-0" />
        <div>
          {!merchantAccount && isFetched ? (
            <InfoBox variant="red">{t('network.server-error')}</InfoBox>
          ) : !merchantAccount ? null : merchantAccount.validationState === 'NOT_CREATED' ? (
            <div className="space-y-2">
              <InfoBox variant="gray">{t('settings-route.t2p.not-created-desc')}</InfoBox>
              <CreateMerchantAccountButton />
            </div>
          ) : merchantAccount.validationState === 'INFO_NEEDED' ? (
            <div className="space-y-2">
              <InfoBox variant="yellow">{t('settings-route.t2p.info-needed-desc')}</InfoBox>
              <GoToStripeOnboardingButton />
            </div>
          ) : merchantAccount.validationState === 'VALIDATING' ? (
            <div className="space-y-2">
              <InfoBox variant="blue">{t('settings-route.t2p.validating-desc')}</InfoBox>
              <GoToStripeOnboardingButton label={t('common.open')} />
            </div>
          ) : merchantAccount.validationState === 'GRANTED' ? (
            <div className="space-y-2">
              <InfoBox variant="green">{t('settings-route.t2p.granted-desc')}</InfoBox>

              <GoToStripeDashboardButton />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
